import { type IApiResponse } from '@/helpers/types';
import { type IActionsForRoleStates, type IActionStates, type IRolesForActionStates } from '@/interface/state/IActionState';
import { getCoreQuery, type IGetQuery } from '@/store/actions/api-utils';

import { coreApiSlice } from '../apiSlice';

export const actionsApiSlice = coreApiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getForMultipleRole: builder.query<IApiResponse<string[]>, { roles: string[] }>({
			query: (body) => ({
				method: 'POST',
				url: '/Action/getActionsForMultipleRoles',
				body,
			}),
		}),
		getActions: builder.mutation<IActionStates, IGetQuery>({
			query: ({ paged, query }) => ({
				method: 'GET',
				url: `/Action${getCoreQuery(paged, ...(query || []))}`,
			}),
		}),
		deleteActionById: builder.mutation<IApiResponse, { actionIds: number[] }>({
			query: (body) => ({
				url: '/Action',
				method: 'DELETE',
				body,
			}),
		}),
		updateAction: builder.mutation<IApiResponse, { id: number; name: string }>({
			query: (body) => ({
				url: '/Action',
				method: 'PUT',
				body,
			}),
		}),
		createAction: builder.mutation<IApiResponse, { name: string }>({
			query: (body) => ({
				url: '/Action',
				method: 'POST',
				body,
			}),
		}),
		getActionForRole: builder.mutation<IActionsForRoleStates, IGetQuery>({
			query: ({ paged, query }) => ({
				method: 'GET',
				url: `/Action/getActionsForRole${getCoreQuery(paged, ...(query || []))}`,
			}),
		}),
		getRolesForActions: builder.query<IRolesForActionStates, { id: string }>({
			query: ({ id }) => ({
				method: 'GET',
				url: `/Action/getRolesForAction/${id}`,
			}),
		}),
		assignMultipleRoles: builder.mutation<IActionsForRoleStates, { roleIds: number[]; actionId: number }>({
			query: (body) => ({
				method: 'POST',
				url: 'Action/assign-multiple-roles',
				body,
			}),
		}),
		unAssignMultipleRoles: builder.mutation<IActionsForRoleStates, { roleIds: number[]; actionId: number }>({
			query: (body) => ({
				method: 'POST',
				url: 'Action/unassign-multiple-roles',
				body,
			}),
		}),
	}),
});

export const {
	useGetForMultipleRoleQuery,
	useGetActionsMutation,
	useDeleteActionByIdMutation,
	useCreateActionMutation,
	useUpdateActionMutation,
	useGetActionForRoleMutation,
	useGetRolesForActionsQuery,
	useLazyGetRolesForActionsQuery,
	useAssignMultipleRolesMutation,
	useUnAssignMultipleRolesMutation,
} = actionsApiSlice;
